/**
 * M7 — continue. The most recent thread as a resumable line: its title and
 * when. A thread that ended in a draft says so. Never dismissable; the
 * "N previous chats" row in zone E holds everything older. The tap is
 * `open`; the host resumes the thread in place.
 */

import { MessageCircle } from 'react-feather';
import { HomeGlyph, HomeRow } from '../HomeKit';
import { whenLabel } from '../format';
import type { ModuleProps } from '../moduleTypes';

export function ContinueModule({ module, onAction }: ModuleProps) {
  if (module.type !== 'continue') return null;
  const { payload } = module;
  const body = payload.draft ? `Finish your draft: “${payload.title}”` : `Pick up: “${payload.title}”`;
  // The reason chip usually already says when; the sub-line only repeats it when it does not.
  const when = whenLabel(payload.when);
  const sub = when && !(module.reason?.text || '').toLowerCase().includes(when.toLowerCase()) ? when : undefined;

  return (
    <HomeRow
      reason={module.reason}
      body={body}
      sub={sub}
      glyph={
        <HomeGlyph tone="violet">
          <MessageCircle size={13} />
        </HomeGlyph>
      }
      dismissable={false}
      onOpen={() => onAction?.({ kind: 'open' }, module)}
    />
  );
}
